import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import fetchLoyaltyActiveCustomRules from 'actions/loyalty/fetchLoyaltyActiveCustomRules'

function useLoyaltyActiveCustomRules(): Set<string> {
  const dispatch = useAppDispatch()

  const rules = useAppSelector(state => state.loyalty.activeCustomRules)

  useEffect(() => {
    dispatch(fetchLoyaltyActiveCustomRules())
  }, [dispatch])

  const activeRuleIdSet = useMemo(() => {
    if (!rules) return new Set<string>()

    const active = rules
      .map(rule => rule.id)

    return new Set(active)
  }, [rules])

  return activeRuleIdSet
}

export default useLoyaltyActiveCustomRules
